export default __webpack_public_path__ + "static/media/weather.6beae0a4.png";